import { render, staticRenderFns } from "./BuyOrdersReport.vue?vue&type=template&id=40059256&"
import script from "./BuyOrdersReport.vue?vue&type=script&lang=js&"
export * from "./BuyOrdersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports